export default "__VITE_ASSET__84cb491c__"